/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Iso3Inputs */

const en_reference_field_iso3 = /** @type {(inputs: Reference_Field_Iso3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ISO 3166 alpha-3`)
};

/**
* | output |
* | --- |
* | "ISO 3166 alpha-3" |
*
* @param {Reference_Field_Iso3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_iso3 = /** @type {((inputs?: Reference_Field_Iso3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Iso3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_iso3(inputs)
});